export const TOP_PRESET = "top";
export const BOTTOM_PRESET = "bottom";
export const LEFT_PRESET = "left";
export const RIGHT_PRESET = "right";
export const TOP_LEFT_PRESET = "top_left";
export const TOP_RIGHT_PRESET = "top_right";
export const BOTTOM_LEFT_PRESET = "bottom_left";
export const BOTTOM_RIGHT_PRESET = "bottom_right";
export const CENTER_PRESET = "center";
export const NONE_PRESET = "none";

export const POSITION_PRESETS = [
  TOP_PRESET,
  BOTTOM_PRESET,
  LEFT_PRESET,
  RIGHT_PRESET,
  TOP_LEFT_PRESET,
  TOP_RIGHT_PRESET,
  BOTTOM_LEFT_PRESET,
  BOTTOM_RIGHT_PRESET,
  CENTER_PRESET,
  NONE_PRESET
];
